import { useProfile } from './useProfile'
import { isAdmin } from '@/lib/auth'

/**
 * Hook to check if the current user is an admin
 * Returns { isAdmin, isLoading } for handling loading states
 */
export function useIsAdmin() {
  const { profile, isLoading } = useProfile()

  return {
    isAdmin: isAdmin(profile),
    isLoading,
  }
}
